<template>
  <v-app id="inspire" class="app dashboard">
    <app-drawer class="app--drawer" :expanded="showDrawer"></app-drawer>
    <app-toolbar class="app--toolbar" @side-icon-click="handleDrawerVisiable"></app-toolbar>
    <v-content>
      <div class="page-wrapper">
        <router-view></router-view>
      </div>
    </v-content>
    <!-- Go to top -->
    <app-fab></app-fab>
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer'
import AppToolbar from '@/components/AppToolbar'
import AppFab from '@/components/AppFab'

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
  },

  data() {
    return {
      showDrawer: false,
    }
  },
  methods: {
    handleDrawerVisiable() {
      this.showDrawer = !this.showDrawer
    },
  },
  created() {},
}
</script>

<style scoped>
.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
